module.exports = "<div class=\"uploader-status\">\r\n  <mat-spinner></mat-spinner>\r\n</div>\r\n"